import { IntlShape } from "react-intl";

// Money on the earnings screens: whole złoty, thin-space grouping from the
// locale, an explicit minus for losses.
// A missing figure is an em dash, never a zero — "we do not know" and "it was
// worth nothing" are different statements, and fixed-price plants legitimately
// have no RDN or PSE leg at all.
export const formatPln = (
  intl: IntlShape,
  value: number | null | undefined,
  digits = 0,
) =>
  value === null || value === undefined
    ? "—"
    : intl.formatNumber(value, {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
      });

export const formatKwh = (intl: IntlShape, value: number | null | undefined) =>
  value === null || value === undefined
    ? "—"
    : intl.formatNumber(value, { maximumFractionDigits: 0 });
